import styled from "@emotion/styled";
import {
  Box,
  Button,
  Divider,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ProductAutocomplete } from "./ProductAutocomplete";
import { CustomerAutocomplete } from "./CustomerAutocomplete";
import useInputObject from "../../../../hooks/useInputObject";
import {
  getChainStoreProduct,
  insertChainStoreProduct,
  updateChainStoreProduct,
} from "../../../../http/api/ChainStoreAPI";
import {
  DEFAULT_CHAIN_STORE_MODAL_STATE,
  MODAL_STATE,
} from "../../../chain_store/ChainStoreUtils";

const ConfiguredModal = styled(Modal)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const ConfiguredBox = styled(Box)({
  backgroundColor: "white",
  padding: 25,
  borderRadius: 5,
  width: 400,
  height: 580,
});

const InputLabelProps = {
  shrink: true,
  style: {
    fontSize: 20,
    fontWeight: 500,
    padding: 0,
  },
};

const InputProps = {
  style: {
    fontSize: 16,
    textAlign: "center",
    height: "100%",
    paddingInline: 0,
  },
};
const INITIAL_STATE = {
  productId: "",
  customerId: "",
  chainStoreProductTypeCd: "",
  chainStoreProductCd: "",
  chainStoreProductName: "",
};

export default function ChainStoreInfoModal(props) {
  const { modalState, onClose } = props;
  const state = useInputObject(INITIAL_STATE);
  const [product, setProduct] = useState({});
  const [customer, setCustomer] = useState({});

  useEffect(() => {
    const productId = product?.productId;
    const customerId = customer?.customerId;
    if (!productId || !customerId) return;
    const FetchChainStoreProduct = async () => {
      if (productId && customerId) {
        try {
          const response = await getChainStoreProduct({
            productId,
            customerId,
          });
          const fetchedData = response.listChainStoreProductInfo[0];
          if (fetchedData) {
            modalState.update("mode", MODAL_STATE.UPDATE);
            modalState.update("updateElement", fetchedData);
            state.setValue(fetchedData);
          }
        } catch {
          state.updates({
            chainStoreProductTypeCd: "",
            chainStoreProductCd: "",
            chainStoreProductName: "",
          });
          if (modalState.Value.isAlien) {
            modalState.update("mode", MODAL_STATE.INSERT);
          }
        }
      }
    };
    FetchChainStoreProduct();
  }, [product, customer]);

  useEffect(() => {
    state.update("productId", product?.productId);
  }, [product]);

  useEffect(() => {
    state.update("customerId", customer?.customerId);
  }, [customer]);
  
  async function handleSubmit() {
    if (modalState.Value.mode === MODAL_STATE.INSERT) {
      try {
        const insertValue = { ...state.Value, createdId: 1 };
        const response = await insertChainStoreProduct(insertValue);
        alert("チェーンストア商品を登録しました。");
      } catch (e) {
        alert("チェーンストア商品を登録できませんでした。", e);
      }
    }
    if (modalState.Value.mode === MODAL_STATE.UPDATE) {
      try {
        const updateValue = { ...state.Value, updatedId: 1 };
        const response = await updateChainStoreProduct(updateValue);
        alert("チェーンストア商品を編集しました。");
      } catch (e) {
        alert("チェーンストア商品を編集できませんでした。", e);
      }
    }
    onCloseModal();
  }

  function onCloseModal() {
    onClose && onClose();
    modalState.setValue(DEFAULT_CHAIN_STORE_MODAL_STATE);
    state.setValue(INITIAL_STATE);
  }

  return (
    <ConfiguredModal
      onBackdropClick={() => {
        onCloseModal();
      }}
      open={modalState.Value.open}
    >
      <ConfiguredBox>
        <Typography
          variant="h6"
          textAlign="left"
          marginBottom={2}
          sx={{ fontWeight: 550 }}
        >
          チェーンストア商品登録
        </Typography>
        <Stack spacing={3}>
          <ProductAutocomplete
            modalState={modalState}
            product={product}
            setProduct={setProduct}
          />
          <Divider />
          <CustomerAutocomplete
            modalState={modalState}
            customer={customer}
            setCustomer={setCustomer}
          />
          <Divider />
          <TextField
            label={"商品種別コード"}
            InputProps={InputProps}
            InputLabelProps={InputLabelProps}
            value={state.Value.chainStoreProductTypeCd}
            onChange={(e) =>
              state.update("chainStoreProductTypeCd", e.target.value)
            }
          ></TextField>
          <Divider />
          <TextField
            label={"チェーンストア商品コード"}
            InputProps={InputProps}
            InputLabelProps={InputLabelProps}
            sx={{ padding: 0, height: "100%" }}
            value={state.Value.chainStoreProductCd}
            onChange={(e) =>
              state.update("chainStoreProductCd", e.target.value)
            }
          ></TextField>
          <Divider />
          <TextField
            label={"チェーンストア品名"}
            InputProps={InputProps}
            InputLabelProps={InputLabelProps}
            value={state.Value.chainStoreProductName}
            onChange={(e) =>
              state.update("chainStoreProductName", e.target.value)
            }
          ></TextField>
          <Divider />
          <Box display="flex" justifyContent={"space-around"}>
            <Button
              variant="contained"
              color={
                modalState.Value.mode === MODAL_STATE.INSERT
                  ? "error"
                  : "primary"
              }
              sx={{ marginInline: 2, width: 100 }}
              onClick={handleSubmit}
            >
              {modalState.Value.mode === MODAL_STATE.INSERT ? "追加" : "編集"}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              sx={{ width: 100 }}
              onClick={() => {
                onCloseModal();
              }}
            >
              戻る
            </Button>
            {/* <Button
              onClick={() => {
                console.log(state.Value);
                console.log(modalState.Value);
              }}
            >
              Check State
            </Button> */}
          </Box>
        </Stack>
      </ConfiguredBox>
    </ConfiguredModal>
  );
}
